import { render, staticRenderFns } from "./Listasmarcar.vue?vue&type=template&id=0b2d3b70&"
import script from "./Listasmarcar.vue?vue&type=script&lang=js&"
export * from "./Listasmarcar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports